export default __webpack_public_path__ + "static/2378-b5eadf6a5e27a4e5aa6c362a9f0114fd.jpg";